import { render, staticRenderFns } from "./InventoryItemColors.vue?vue&type=template&id=244415b4&scoped=true"
import script from "./InventoryItemColors.vue?vue&type=script&lang=js"
export * from "./InventoryItemColors.vue?vue&type=script&lang=js"
import style0 from "./InventoryItemColors.vue?vue&type=style&index=0&id=244415b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244415b4",
  null
  
)

export default component.exports